// SellOrderBookTable3.js - FIXED FOR BATCHING
import React, { useMemo, useState, useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import OrderBookVirtualizedTemplate from './OrderBookVirtualizedTemplate';
import {
   ADD_ROW, DELETE_ROW, UPDATE_ROW, TABLE_HEADER_PRIORITY, TABLE_HEADER_QTY, TABLE_HEADER_PRICE,
   ConvertOrderAndTradeStatus, FormatPriceAndQty, INSTRUMENT_SELECTED,
   JSON_KEY_PRICE, JSON_KEY_QTY, JSON_KEY_PRIORITY,
   MARKET_PRICE_TAG, SELLORDERBOOK_TABLE,
} from '../../common/common';
import { selectTableData, selectTSUserId } from '../../redux/globalsSlice';
import { updateTableColumnWidths } from '../../redux/panelPositionsSlice';

const SellOrderBookTable3 = () => {
   const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const instrumentsTableData = useSelector(selectTableData);
   const instrumentsTableDataRef = useRef({});
   const [selectedInstrument, setSelectedInstrument] = useState(null);

   const savedColumnWidths = useSelector(
      state => state.panelPositions?.tableStates?.[tsUserId]?.[SELLORDERBOOK_TABLE]?.columnWidths ?? null
   );

   const handleColumnWidthsChange = useCallback((columnWidths) => {
      if (!tsUserId) return;
      dispatch(updateTableColumnWidths({
         userId: tsUserId,
         tableId: SELLORDERBOOK_TABLE,
         columnWidths,
      }));
   }, [dispatch, tsUserId]);

   useEffect(() => {
      instrumentsTableDataRef.current = instrumentsTableData;
   }, [instrumentsTableData]);

   // Listen for instrument selection events
   useEffect(() => {
      const handleInstrumentSelection = (event) => {
         if (event.detail?.type === INSTRUMENT_SELECTED) {
            setSelectedInstrument(event.detail.data);
         }
      };

      window.addEventListener('SellOrderBookTable', handleInstrumentSelection);
      return () => window.removeEventListener('SellOrderBookTable', handleInstrumentSelection);
   }, []);
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[SellOrderBookTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[SellOrderBookTable] Row Double Clicked:`, rowData);
   }, []);

   // FIXED: Standard event handler that works with batching
   const handleEvents = useCallback((details, setLocalTableData) => {
      const rawRow = details.data;
      const price = details.data?.price ?? MARKET_PRICE_TAG;

      const formattedRow = {
         id: rawRow.priority,
         instr: rawRow.instr, // CRITICAL: Include instrument for filtering
         ...FormatPriceAndQty(rawRow, price, details.data.qty, instrumentsTableDataRef.current),
         status: ConvertOrderAndTradeStatus(rawRow.status),
      };

      // Use standard React setState pattern
      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               if (prev.some(row => row.id === formattedRow.id)) {
                  return prev;
               }
               return [...prev, formattedRow];
            });
            break;

         case UPDATE_ROW:
            setLocalTableData(prev => 
               prev.map(row => row.id === formattedRow.id ? { ...row, ...formattedRow } : row)
            );
            break;

         case DELETE_ROW:
            setLocalTableData(prev => 
               prev.filter(row => row.id !== formattedRow.id)
            );
            break;

         default:
            break;
      }
   }, []);

   const columns = useMemo(() => [
      { Header: TABLE_HEADER_PRICE, accessor: JSON_KEY_PRICE },
      { Header: TABLE_HEADER_QTY, accessor: JSON_KEY_QTY },
      { Header: TABLE_HEADER_PRIORITY, accessor: JSON_KEY_PRIORITY },
   ], []);

   return (
      <OrderBookVirtualizedTemplate
         columns={columns}
         eventHandlers={handleEvents}
         tableName="SellOrderBookTable"
         tableId={SELLORDERBOOK_TABLE}
         userId={tsUserId}
         initialColumnWidths={savedColumnWidths}
         onColumnWidthsChange={handleColumnWidthsChange}
         onRowClick={handleSingleClick}
         onRowDoubleClick={handleDoubleClick}
         filterByInstrument={selectedInstrument}
         columnColors={{
            0: 'red'
         }}
         side="Sell"
      />
   );
};

export default SellOrderBookTable3;